export default __webpack_public_path__ + "cccf1cce55030f8fb31481cebc41cf89.svg";